import { useState } from "react";
import {
  SimpleGrid,
  VStack,
  Text,
  Link,
  Image,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
  Stack,
  HStack,
  Icon,
  Tooltip,
} from "@chakra-ui/react";
import { RxExternalLink } from "react-icons/rx";

// TODO: confirmar/ajustar el QR de cada link. La asignación actual es tentativa
// (orden cronológico de las imágenes en ./QR/). Cuando llegue el mapeo, basta con
// cambiar la propiedad `qr` de cada item por la imagen correspondiente.
import qr1 from "./QR/image-20260514-125559.png";
import qr2 from "./QR/image-20260514-125706.png";
import qr3 from "./QR/image-20260514-125734.png";
import qr4 from "./QR/image-20260514-125823.png";
import qr5 from "./QR/image-20260514-125911.png";
import qr6 from "./QR/image-20260514-125928.png";

const links = [
  {
    nombre: "Checklist Preoperativo Trailers RG91",
    url: "https://forms.cloud.microsoft/r/1ZW2g24Pgt?origin=lprLink",
    qr: qr1,
  },
  {
    nombre: "Checklist Entrega - Retiro de Filtros BRENT",
    url: "https://forms.cloud.microsoft/r/RsSR5yUXVm?origin=lprLink",
    qr: qr2,
  },
  {
    nombre: "DTM Última Milla de Arena RG-49 – Coordinación",
    url: "https://forms.cloud.microsoft/r/MYtGNcfaFK?origin=lprLink",
    qr: qr3,
  },
  {
    nombre: "DTM Última Milla de Arena RG-49 – Supervisión",
    url: "https://forms.cloud.microsoft/r/9S7DX5bL50?origin=lprLink",
    qr: qr4,
  },
  {
    nombre: "Control de Elementos Prepad RG 93",
    url: "https://forms.cloud.microsoft/r/0HgJiGeixF?origin=lprLink",
    qr: qr5,
  },
  {
    nombre: "Checklist de DTM Pisos",
    url: "https://forms.cloud.microsoft/r/QAgQzd9q9u?origin=lprLink",
    qr: qr6,
  },
];

const LinksForms = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [qrActivo, setQrActivo] = useState(null);

  const ampliarQr = (item) => {
    setQrActivo(item);
    onOpen();
  };

  return (
    <Stack w={"100%"} paddingInline={6}>
      <Heading
        fontWeight="medium"
        size="xl"
        fontFamily="fonts.title"
        color="brand.gris_primario"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        Links de formularios
      </Heading>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
        {links.map((item) => (
          <VStack
            key={item.url}
            spacing={3}
            p={4}
            bg="white"
            borderWidth="1px"
            borderRadius="lg"
            boxShadow="sm"
            align="center"
            textAlign="center"
          >
            <Tooltip
              hasArrow
              label="Abrir formulario en nueva pestaña"
              fontSize="xs"
              bg="brand.gris_secundario"
              color="white"
              placement="right"
            >
              <Link
                href={item.url}
                isExternal
                fontWeight="semibold"
                _hover={{ color: "brand.naranja" }}
                color="brand.azul_text"
                justifyContent="space-between"
                alignItems="center"
              >
                <HStack>
                  <Text>{item.nombre}</Text>
                  <Icon as={RxExternalLink} color="gray.400" boxSize={4} />
                </HStack>
              </Link>
            </Tooltip>
            <Image
              src={item.qr}
              alt={`QR ${item.nombre}`}
              boxSize="160px"
              objectFit="contain"
              cursor="pointer"
              onClick={() => ampliarQr(item)}
            />
            <Text fontSize="xs" color="gray.500">
              Clic en el QR para ampliarlo
            </Text>
          </VStack>
        ))}
      </SimpleGrid>

      <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody py={10}>
            <VStack spacing={4}>
              <Text fontWeight="semibold" textAlign="center">
                {qrActivo?.nombre}
              </Text>
              {qrActivo && (
                <Image
                  src={qrActivo.qr}
                  alt={`QR ${qrActivo.nombre}`}
                  w="100%"
                  maxW="420px"
                  objectFit="contain"
                />
              )}
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Stack>
  );
};

export default LinksForms;
